// @ts-check

/**
 * Texto que es solo referencias `recent:` / `file:` (no subibles como File en el navegador).
 * Sirve para el valor del textarea tras pegar, cuando `clipboardData` no expone la URI en el `paste`.
 *
 * @param {string} text
 */
export function isOnlyFilesystemUriPasteText(text) {
  const t = String(text).replace(/^\uFEFF/, "").trim()
  if (!t) return false
  const lines = t.split(/\r?\n/).map((l) => l.trim()).filter(Boolean)
  if (lines.length === 0) return false
  return lines.every((line) => isFilesystemUriPasteLine(line))
}

/**
 * @param {string} line
 */
function isFilesystemUriPasteLine(line) {
  if (/^(recent|file):\/\//i.test(line)) return true
  if (/^recent:[^\s]+$/i.test(line)) return true
  return false
}
